import { Vue, Watch, Component } from 'vue-property-decorator';
import { RmaModel, RmaListModel } from './Rma.model';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import { rmaFilterService } from './Rma.services';
import moment from 'moment';
import AddRma  from '@/components/AddRma/AddRma.vue';

@Component({
    components:{
        datePicker,
        AddRma
    }
})
export default class RmaList extends Vue{
    public rmaModel!: RmaModel;
    public rmaListModel: RmaListModel[] =[];
    public startDate: string = '';
    public endDate: string = '';
    public options: any;
    public selectAllValue: boolean = false;
    public startDateDisabled: boolean = true;
    public endDateDisabled: boolean = true;
    public readonly: boolean = true;
    public arrayList: any;
    public options2: any;
    public selected:any = [];
    public fullPage: boolean = false;
    public $loading: any;
    public apiCalled: boolean = false;
    public checkedNames: any = [];

    data(){
        return{
            rmaModel: new RmaModel(),
            rmaListModel: [],
            arrayList: [],
            startDate: '',
            endDate: '',
            apiCalled: false,
            checkedNames:[],
            options: {
            format: 'YYYY-MM-DD',
            useCurrent: false,
            },
            options2: {
                format: 'YYYY-MM-DD',
                useCurrent: false,
                minDate: null
                },
            readonly: false,
            selectAllValue: true,
            startDateDisabled: true,
            endDateDisabled: true,
            headers: [
                {
                  text: 'Invoice No',
                  align: 'left',
                  sortable: true,
                  value: 'invoice_number',
                },
                { text: 'Order ID', value: 'order_id',align:'center' },
                { text: 'Rma Status', value: 'rma_status',align:'left'},
                { text: 'Date Issued', value: 'date_issued', align:'left'},
                { text: 'Date Updated', value:'date_updated',align:'left'},
                { text: 'Date Approved', value: 'date_approved', align:'left'},
                { text: 'Staff Type', value: 'staff_username',align:'left'}
              ],
              search:'',
              pagination: {
                ascending: true,
                sortBy:"invoice_number",
                rowsPerPage: 25,
                page: 1
            },
            json_fields: {
                'Invoice Number': 'invoice_number',
                'Order ID': 'order_id',
                'Rma STatus': 'rma_status',
                'Date Issued': 'date_issued',
                'Date Updated': 'date_updated',
                'Date Approved': 'date_approved',
                'Staff Type': 'staff_username'
            }
        }
    }
    beforeMount(){
        window.scrollTo(0,0);
    }
    mounted(){
        console.log("rma list mounted successfully");
    }
    filterRma(){
        this.getFilterRma();
    }

    @Watch('rmaModel.date_type')
    onDateTypeChanged(value:string,oldValue:string){
        if(value !== "" && value !==null){
            this.startDateDisabled = false;
        }else{
            this.startDateDisabled = true;
            if(this.rmaModel.start_date){
                this.rmaModel.start_date = '';
            }
        }
    }

    @Watch('rmaModel.start_date')
    onStartDateChanged(value: string, oldValue: string){
        if(value !== "" && value !==null){
            this.endDateDisabled = false;
            this.options2.minDate = moment(this.rmaModel.start_date).format('YYYY-MM-DD');

        }else{
            this.endDateDisabled = true;
            this.options2.minDate = null;
            if(this.rmaModel.end_date){
                this.rmaModel.end_date = '';
            }
        }
    }

    @Watch('selectAllValue')
    onSelectAllChanged(value: string,oldValue:string){
        // console.log(this.checkedNames.length)
        
    }

    onAddRma(){
        console.log("Hello");
        if(this.selected.length === 0){
            this.selected = this.rmaListModel;  
            this.selected.forEach((element) => {
                this.checkedNames.push(parseInt(element.id));
                this.selected = this.rmaListModel;
            });
        }else{
            this.selected = [];
            this.selectAllValue = false;
            this.checkedNames = [];
        }
    }
    
    public async getFilterRma(): Promise<void>{
        let postData = {
            data: this.rmaModel
        }
        let loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false,
            // onCancel: this.onCancel,
          });
        
        const res = rmaFilterService.getFilteredData(postData).then((response: any) => {
            this.rmaListModel = response.data.data.rma_list;
            loader.hide();
            this.apiCalled = true;    
        }).catch((error:any) => {
            console.log(error);
            loader.hide();
        })
    }
    showAlert(id:any){
        let rma_id = localStorage.getItem("RmaID");
        if (rma_id === undefined || rma_id === null){
            localStorage.setItem("RmaID",String(id));
        }else{
            localStorage.removeItem("RmaID");
            localStorage.setItem("RmaID",String(id));
        }
        this.$router.push('/rma-status');
    }
    addToSelected(id:any,event:any){
        this.checkedNames.forEach(element => {
            let data = this.rmaListModel.filter(function(item:any) { return item.id === id; });
            console.log(data);
            this.selected.push(data[0]);
        });
        
        // console.log(this.$refs['check-'+id]);
        console.log(this.checkedNames);
        
    }
}